import React, { useState, useRef, useEffect } from 'react';
import { Train } from 'lucide-react';

interface StationEntry {
  name: string;
  line: string;
  lineShort: string;
  color: string;
}

const MUMBAI_STATIONS: StationEntry[] = [
  // ── Western Line (Churchgate → Virar) ──
  { name: 'Churchgate', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Marine Lines', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Charni Road', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Grant Road', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Mumbai Central', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Mahalaxmi', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Lower Parel', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Prabhadevi', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Dadar', line: 'Western / Central Line', lineShort: 'WR/CR', color: 'bg-purple-100 text-purple-700' },
  { name: 'Matunga Road', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Mahim', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Bandra', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Khar Road', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Santacruz', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Vile Parle', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Andheri', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Jogeshwari', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Ram Mandir', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Goregaon', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Malad', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Kandivali', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Borivali', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Dahisar', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Mira Road', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Bhayander', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Naigaon', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Vasai Road', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Nala Sopara', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },
  { name: 'Virar', line: 'Western Line', lineShort: 'WR', color: 'bg-blue-100 text-blue-700' },

  // ── Central Line (CSMT → Kasara / Khopoli) ──
  { name: 'CSMT', line: 'Central / Harbour Line', lineShort: 'CR/H', color: 'bg-red-100 text-red-700' },
  { name: 'Masjid', line: 'Central / Harbour Line', lineShort: 'CR/H', color: 'bg-red-100 text-red-700' },
  { name: 'Sandhurst Road', line: 'Central / Harbour Line', lineShort: 'CR/H', color: 'bg-red-100 text-red-700' },
  { name: 'Byculla', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Chinchpokli', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Currey Road', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Parel', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Matunga', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Sion', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kurla', line: 'Central / Harbour Line', lineShort: 'CR/H', color: 'bg-orange-100 text-orange-700' },
  { name: 'Vidyavihar', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Ghatkopar', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Vikhroli', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kanjurmarg', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Bhandup', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Nahur', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Mulund', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Thane', line: 'Central / Trans-Harbour', lineShort: 'CR/TH', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kalwa', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Mumbra', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Diva', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kopar', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Dombivali', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Thakurli', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kalyan', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Shahad', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Ambivali', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Titwala', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Khadavli', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Wangani', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Khardi', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Asangaon', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kasara', line: 'Central Line', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  // Pune branch (Kalyan → Khopoli)
  { name: 'Vithalwadi', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Ulhasnagar', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Ambernath', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Badlapur', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Vangani', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Shelu', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Neral', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Bhivpuri Road', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Karjat', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Palasdhari', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Kelavali', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Dolavali', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Lowjee', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },
  { name: 'Khopoli', line: 'Central Line (Pune Branch)', lineShort: 'CR', color: 'bg-orange-100 text-orange-700' },

  // ── Harbour Line (CSMT → Panvel) ──
  { name: 'Dockyard Road', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Reay Road', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Cotton Green', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Sewri', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Wadala Road', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Wadala', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'GTB Nagar', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Chunabhatti', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Tilaknagar', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Chembur', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Govandi', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Mankhurd', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Vashi', line: 'Harbour / Trans-Harbour', lineShort: 'HBR/TH', color: 'bg-green-100 text-green-700' },
  { name: 'Sanpada', line: 'Harbour / Trans-Harbour', lineShort: 'HBR/TH', color: 'bg-green-100 text-green-700' },
  { name: 'Juinagar', line: 'Harbour / Trans-Harbour', lineShort: 'HBR/TH', color: 'bg-green-100 text-green-700' },
  { name: 'Nerul', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Seawoods-Darave', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Belapur CBD', line: 'Harbour / Trans-Harbour', lineShort: 'HBR/TH', color: 'bg-green-100 text-green-700' },
  { name: 'Kharghar', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Mansarovar', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Khandeshwar', line: 'Harbour Line', lineShort: 'HBR', color: 'bg-green-100 text-green-700' },
  { name: 'Panvel', line: 'Harbour / Trans-Harbour', lineShort: 'HBR/TH', color: 'bg-green-100 text-green-700' },

  // ── Trans-Harbour Line (Thane → Panvel) ──
  { name: 'Airoli', line: 'Trans-Harbour Line', lineShort: 'TH', color: 'bg-teal-100 text-teal-700' },
  { name: 'Rabale', line: 'Trans-Harbour Line', lineShort: 'TH', color: 'bg-teal-100 text-teal-700' },
  { name: 'Ghansoli', line: 'Trans-Harbour Line', lineShort: 'TH', color: 'bg-teal-100 text-teal-700' },
  { name: 'Kopar Khairane', line: 'Trans-Harbour Line', lineShort: 'TH', color: 'bg-teal-100 text-teal-700' },
  { name: 'Turbhe', line: 'Trans-Harbour Line', lineShort: 'TH', color: 'bg-teal-100 text-teal-700' },

  // ── Metro Line 1 (Versova ↔ Ghatkopar) ──
  { name: 'Versova', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'D.N. Nagar', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Azad Nagar', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Andheri Metro', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Western Express Highway', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Chakala (JB Nagar)', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Airport Road', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Marol Naka', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Saki Naka', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Asalpha', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Jagruti Nagar', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },
  { name: 'Ghatkopar Metro', line: 'Metro Line 1', lineShort: 'M1', color: 'bg-yellow-100 text-yellow-700' },

  // ── Metro Line 2A (Dahisar E ↔ D.N. Nagar) ──
  { name: 'Dahisar East', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Anand Nagar', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Kandarpada-Dahanukarwadi', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Eksar', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Borivali East', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Pahadi Goregaon', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Goregaon East', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Aarey', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'JVLR', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Jogeshwari East', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Dindoshi', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Malad East', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Kurar Village', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Akurli', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Poisar', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Devipada-Bangurwadi', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Ovaripada', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Pahadi Eksar', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Magathane', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },
  { name: 'Mandapeshwar', line: 'Metro Line 2A', lineShort: 'M2A', color: 'bg-pink-100 text-pink-700' },

  // ── Metro Line 7 (Andheri E ↔ Dahisar E) ──
  { name: 'Andheri East', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Chakala', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Sahar Road', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Domestic Airport', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'International Airport', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Marol Naka Metro 7', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'MIDC', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Saki Naka Metro 7', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Jarimari', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Bhandup Complex', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Sanjay Nagar', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Gundavali', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Aarey Colony', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Rashtriya Udyan', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
  { name: 'Dahisar East Metro 7', line: 'Metro Line 7', lineShort: 'M7', color: 'bg-indigo-100 text-indigo-700' },
];

interface Props {
  value: string;
  onChange: (val: string) => void;
  className?: string;
  placeholder?: string;
}

const StationSelect: React.FC<Props> = ({ value, onChange, className = '', placeholder = 'Search station...' }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value);
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  // Sync external value into query when it changes from outside
  useEffect(() => {
    setQuery(value);
  }, [value]);

  // Close on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = query.trim().length === 0
    ? []
    : MUMBAI_STATIONS.filter(s =>
        s.name.toLowerCase().includes(query.toLowerCase())
      ).slice(0, 12);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setQuery(val);
    onChange(val);        // allow freeform
    setOpen(true);
  };

  const handleSelect = (station: StationEntry) => {
    setQuery(station.name);
    onChange(station.name);
    setOpen(false);
    inputRef.current?.blur();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      setOpen(false);
    }
    if (e.key === 'Enter' && filtered.length === 1) {
      handleSelect(filtered[0]);
      e.preventDefault();
    }
  };

  return (
    <div ref={containerRef} className="relative">
      <div className="relative">
        <Train className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
        <input
          ref={inputRef}
          type="text"
          value={query}
          onChange={handleInput}
          onFocus={() => query.trim().length > 0 && setOpen(true)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          autoComplete="off"
          className={`${className} pl-8`}
        />
      </div>

      {open && filtered.length > 0 && (
        <ul className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto">
          {filtered.map((s, i) => (
            <li
              key={i}
              onMouseDown={(e) => { e.preventDefault(); handleSelect(s); }}
              className="flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-blue-50 border-b border-gray-50 last:border-0"
            >
              <span className="font-medium text-gray-800">{s.name}</span>
              <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${s.color}`}>{s.lineShort}</span>
            </li>
          ))}
          {/* Freeform hint when query doesn't exactly match any station */}
          {!MUMBAI_STATIONS.some(s => s.name.toLowerCase() === query.toLowerCase()) && query.trim().length > 0 && (
            <li
              onMouseDown={(e) => { e.preventDefault(); setOpen(false); }}
              className="px-3 py-2 text-xs text-gray-400 italic"
            >
              Press Enter or continue typing to use &quot;{query}&quot; as-is
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default StationSelect;
